module.exports = __webpack_public_path__ + "static/media/28.687ea423.mp3";